module.exports = __webpack_public_path__ + "img/person-2.e5299c0c.jpg";